/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Situationaddabandonment2Inputs */

const en_situationaddabandonment2 = /** @type {(inputs: Situationaddabandonment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell the assistant when the contractor went quiet`)
};

const pt_situationaddabandonment2 = /** @type {(inputs: Situationaddabandonment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte ao assistente quando o empreiteiro se calou`)
};

/**
* | output |
* | --- |
* | "Tell the assistant when the contractor went quiet" |
*
* @param {Situationaddabandonment2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const situationaddabandonment2 = /** @type {((inputs?: Situationaddabandonment2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Situationaddabandonment2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_situationaddabandonment2(inputs)
	return pt_situationaddabandonment2(inputs)
});
export { situationaddabandonment2 as "situationAddAbandonment" }